<template>
    <div class="loader">
        <font-awesome-icon icon="spinner-third" size="4x" spin></font-awesome-icon>
        <div>{{$t('app.loadingApp')}}</div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'loadingMainApp',
  components: { FontAwesomeIcon }
};
</script>

<style scoped lang="scss">
    .loader {
        position: absolute;
        top: 50%;
        text-align: center;
        width: 100%;
        transform: translateY(-50%);
    }
</style>
